export default "__VITE_ASSET__DyD$xKzZ__"